module.exports = __webpack_public_path__ + "img/profil_lapper_elsa.bcde92c9.png";